import { createRoot } from 'react-dom/client';
import React from "react";
import PaymentPage from "./paymentPage";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";

const Initialise = () => {
	const buyItNowOrderPayment = document.getElementById("buyItNowOrderPayment");
	if (!buyItNowOrderPayment) {
		return;
	}
	const paymentData = JSON.parse(buyItNowOrderPayment.dataset.appPayment);
	const stripePromise = loadStripe(paymentData.publishableKey);

	const appearance = {
		theme: 'stripe'
	};

	const options = {
		clientSecret: paymentData.clientSecret,
		appearance
	};

	const root = createRoot(buyItNowOrderPayment);

	root.render(<Elements stripe={stripePromise} options={options}>
		<PaymentPage paymentData={paymentData} stripe={stripePromise} />
	</Elements>);
};

export default Initialise;
